import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  overflow-y: scroll;
  overflow-x: hidden;
  background-color: #fff;

  .form-control {
    width: 1050% !important;
    height: 50px;
    border-radius: 4px;
    background-color: #fff;
    border: 1px solid ${({ error }) => (error ? "red" : "#b2b2b2")};
  }

  .form-control {
    font-size: 14px;
    color: #272727;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;

  margin: 80px auto 0; 
  max-width: 1200px;

  @media (max-width: 992px){
    max-width: 970px;
    margin: 80px auto 0; 
    flex-direction: column-reverse;
  }
  
  @media (max-width: 768px) {
    max-width: 750px;
    margin: 80px auto 0; 
    flex-direction: column-reverse;
  }
  
  @media (max-width: 576px){
    max-width: 540px;
    margin: 60px auto 0; 
    flex-direction: column-reverse;
  }
`;

export const FormContainer = styled.div`
  width: 590px;

  div {
    display: flex;
    flex-direction: row;
  }

  @media(max-width: 992px) {
    width: 100%;
  }
`;

export const WrapperTitle = styled.div`
  width: 570px;
  display: flex;
  align-items: center;
  z-index: 2;

  margin-top: -10px;
  margin-bottom: 10px;

  @media(max-width: 992px) {
    width: 100%;
  }
`;

export const Circle = styled.div`
  width: 50px;
  height: 50px;
  margin: 10px 17px;
  border-radius: 50%;
  background-color: #3CACFC ;
  z-index: 2;

  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 50px;
    height: 50px;
  }
`;

export const Title = styled.h3`
  color: #222;
  font-size: 25px;
  font-weight: 700;
  line-height: 30px;
  font-family: 'Montserrat', sans-serif;

  margin-right: 17px;
`;

export const Line = styled.div`
  height: auto;
  z-index: 1;
  width: 3px !important;
  background-color: #3CACFC;
  margin: -50px 0px -20px 40px;
`;

export const FormContent = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 0 60px 20px 42px;

  .inputAutoCompleteEmail {
    opacity: 0;
    height: 0px;
    border: none;
  }
`;

export const WrapperTypePerson = styled.div`
  gap: 20px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  margin-bottom: 37px;

`;

export const WrapperInvalidPassword = styled.div`
  display: flex;
  flex-direction: column !important;
  margin-bottom: 15px;

  div {
    display: flex;
    align-items: center;
    gap: 5px;
    margin-bottom: 5px;

    p {
      font-size: 14px;
    }
  }
`;

export const ButtonNext = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;

  border: none;
  cursor: pointer;
  margin-top: 30px;
  border-radius: 30px;
  background-color: #3cacfc;
  
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  padding: 15px 33px;
  text-transform: uppercase;

  &:hover {
    filter: brightness(.9);
    transition: .2s;
  }
`;

export const ButtonCloseModal = styled.button`
  width: 100%;
  max-width: 309px;
  height: 30px !important;

  font-size: 14px;
  font-weight: 500;
  color: #fff !important;
  font-family: "Work Sans", sans-serif;
  
  cursor: pointer;
  margin-bottom: 16px;
  border-radius: 26px;
  padding: 0 30px!important;
  border: 1px solid #3DA8FE !important;
  background-color: #3DA8FE !important;
`;

export const WrapperCheckboxInfluencer = styled.div`
  display: flex;
  gap: 10px;
  flex-direction: column !important;
  margin-bottom: 20px;

  label {
    font-size: 13px;
    font-weight: 500;
    background-color:  #fff;
    color: #000;
  }
`;
